import {
  AgorapulseLogo,
  BambooHRLogo,
  BitvavoLogo,
  CanonLogo,
  DoodleLogo,
  FrontifyLogo,
  HellowattLogo,
  KarbonLogo,
  LegalstartLogo,
  LogitechLogo,
  LushLogo,
  NedapLogo,
  OmnisendLogo,
  OuihelpLogo,
  PVCaseLogo,
  QuattLogo,
  ShippeoLogo,
  UScreenLogo,
  VirginMediaLogo,
  VismaLogo,
  WecasaLogo,
} from './SVGCustomerLogos'

export const sliteWebsiteCustomerList = [
  { name: 'Doodle', logo: DoodleLogo, migratedFrom: 'Notion' },
  { name: 'Lush', logo: LushLogo, migratedFrom: 'Confluence' },
  { name: 'Frontify', logo: FrontifyLogo, migratedFrom: 'ClickUp' },
  { name: 'Karbon', logo: KarbonLogo, migratedFrom: 'Quip' },
  { name: 'Visma', logo: VismaLogo, migratedFrom: 'OneNote' },
  { name: 'Omnisend', logo: OmnisendLogo, migratedFrom: 'Confluence' },
]

export const defaultSliteCustomerList = [
  { name: 'Bitvavo', logo: BitvavoLogo },
  { name: 'Lush', logo: LushLogo },
  { name: 'Doodle', logo: DoodleLogo },
  { name: 'Canon', logo: CanonLogo },
  { name: 'Logitech', logo: LogitechLogo },
  { name: 'Virgin Media', logo: VirginMediaLogo },
  { name: 'Visma', logo: VismaLogo },
  { name: 'BambooHR', logo: BambooHRLogo },
  { name: 'Karbon', logo: KarbonLogo },
  { name: 'Nedap', logo: NedapLogo },
  { name: 'Frontify', logo: FrontifyLogo },
  { name: 'Uscreen', logo: UScreenLogo },
]

export const extendedSliteCustomerList = [
  { name: 'Bitvavo', logo: BitvavoLogo },
  { name: 'Lush', logo: LushLogo },
  { name: 'Canon', logo: CanonLogo },
  { name: 'Logitech', logo: LogitechLogo },
  { name: 'Virgin Media', logo: VirginMediaLogo },
  { name: 'Visma', logo: VismaLogo },
  { name: 'BambooHR', logo: BambooHRLogo },
  { name: 'Karbon', logo: KarbonLogo },
  { name: 'Nedap', logo: NedapLogo },
  { name: 'Frontify', logo: FrontifyLogo },
  { name: 'Doodle', logo: DoodleLogo },
  { name: 'Uscreen', logo: UScreenLogo },
  { name: 'Hellowatt', logo: HellowattLogo },
  { name: 'PVCase', logo: PVCaseLogo },
  { name: 'Legalstart', logo: LegalstartLogo },
  { name: 'Shippeo', logo: ShippeoLogo },
  { name: 'Wecasa', logo: WecasaLogo },
  { name: 'Quatt', logo: QuattLogo },
  { name: 'Ouihelp', logo: OuihelpLogo },
]

export const defaultSuperCustomerList = [
  { name: 'Visma', logo: VismaLogo },
  { name: 'Karbon', logo: KarbonLogo },
  { name: 'Nedap', logo: NedapLogo },
  { name: 'Agorapulse', logo: AgorapulseLogo },
  { name: 'Frontify', logo: FrontifyLogo },
  { name: 'Uscreen', logo: UScreenLogo },
]

export const defaultKnowledgeSuiteCustomerList = [
  { name: 'agorapulse', logo: AgorapulseLogo },
  { name: 'nedap', logo: NedapLogo },
  { name: 'visma', logo: VismaLogo },
  { name: 'uscreen', logo: UScreenLogo },
  { name: 'karbon', logo: KarbonLogo },
  { name: 'frontify', logo: FrontifyLogo },
]
